'use client';

import { ComponentProps, ReactNode } from 'react';
import Button from '@alltrails/denali/components/Button';
import useScrollerNavNavigation from '../../hooks/useScrollerNavNavigation';
import type { NavItem, Section } from './types';
import { ScrollerNavInternal } from './ScrollerNavInternal';
import NavSection from './NavSection';

export function ScrollerNav({
  title,
  items,
  ctaInfo,
  sections
}: {
  title: ReactNode;
  items: NavItem[];
  ctaInfo?: ComponentProps<typeof Button>;
  sections?: Section[];
}) {
  const { onTabChange, onSectionScrolledIntoView, selectedTab } = useScrollerNavNavigation(items);

  return (
    <>
      <ScrollerNavInternal items={items} title={title} selectedTab={selectedTab} onTabChange={onTabChange} ctaInfo={ctaInfo} />
      {sections?.map(({ id, content }) => (
        <NavSection id={id} key={id} onSectionScrolledIntoView={onSectionScrolledIntoView}>
          {content}
        </NavSection>
      ))}
    </>
  );
}
